"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  email: 'ip@level.travel',
  viewParams: {
    countryRu: 'в Сочи',
    startDate: '2020-10-15',
    nightCount: 14,
    hasFlexDates: true,
    hasFlexNights: true
  },
  subscriptionParams: {
    adults: 3,
    nights: [5, 6, 7, 8, 9],
    kids: [1, 2],
    place_ids: [11502],
    departure_ids: [213],
    start_date_from: '2020-10-13',
    start_date_to: '2020-10-15'
  }
};
exports["default"] = _default;